import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SignupRoutingModule } from './signup-routing.module';
import { SignupComponent } from './signup.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormModule} from '../layout/form/form.module';
import {MatNativeDateModule} from '@angular/material';
import { ConfirmationPageComponent } from './confirmation-page/confirmation-page.component';
import {NgxSpinnerModule} from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SignupRoutingModule,
      ReactiveFormsModule,
      FormModule,
      MatNativeDateModule,
      NgxSpinnerModule,
      FormsModule
  ],
    exports: [MatNativeDateModule],
  declarations: [SignupComponent, ConfirmationPageComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SignupModule { }
